export const BLACKLISTED_FILTERS = [
  'productsCount',
  'selectedCategory',
  'selectedBrand',
  'minPrice',
  'maxPrice',
  'selectedPriceFrom',
  'selectedPriceTo',
  'velkost-displeja'
]
